const initFaqAnimation = () => {
  document.querySelectorAll('.pdp-faq').forEach((section) => {
    section.querySelectorAll('accordion-custom').forEach((item) => {
      const details = /** @type {HTMLDetailsElement | null} */ (item.querySelector(':scope > details'));
      const answer = /** @type {HTMLElement | null} */ (item.querySelector('[data-faq-answer]'));

      if (!details || !answer) return;

      answer.style.maxHeight = details.open ? `${answer.scrollHeight}px` : '0px';

      details.addEventListener('toggle', () => {
        answer.style.maxHeight = details.open ? `${answer.scrollHeight}px` : '0px';
      });
    });
  });
};

customElements.whenDefined('accordion-custom').then(initFaqAnimation);
